export const PageHero = ({ title, subtitle, eyebrow, image }) => (
    <section
        className="relative overflow-hidden border-b border-border bg-[hsl(var(--secondary))]"
        data-testid="page-hero"
    >
        <div className="absolute inset-0 grain-bg opacity-70 pointer-events-none" />
        {image && (
            <div className="absolute inset-0 opacity-15">
                <img
                    src={image}
                    alt=""
                    className="w-full h-full object-cover"
                    loading="lazy"
                />
            </div>
        )}
        <div className="container-wide relative py-16 sm:py-20">
            {eyebrow && (
                <div className="flex items-center gap-3 mb-3">
                    <span className="accent-bar" />
                    <span className="text-[hsl(var(--accent))] font-semibold text-xs uppercase tracking-widest">
                        {eyebrow}
                    </span>
                </div>
            )}
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-foreground max-w-3xl">
                {title}
            </h1>
            {subtitle && (
                <p className="mt-4 text-lg text-muted-foreground max-w-2xl leading-relaxed">
                    {subtitle}
                </p>
            )}
        </div>
    </section>
);

export default PageHero;
